import React from 'react';
import { message, Input, Select, DatePicker, Switch, InputNumber } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import auth from '../../../common/utility/auth';

import { CONVERSION_MEDIDA } from "../../../common/types/parametroType";
import { lst_tipo_afectacion } from "../../../common/types/tipoAfectacion";

import productoService from '../../../service/administracion/productoService';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';
import existenciaService from '../../../service/administracion/existenciaService';
import marcaService from '../../../service/administracion/marcaService';
import modeloService from '../../../service/administracion/modeloService';
import atributoService from '../../../service/administracion/atributoService';

import planCuentaService from '../../../service/administracion/planCuentaService';
import segmentoSunatService from '../../../service/administracion/segmentoSunatService';
import familiaSunatService from '../../../service/administracion/familiaSunatService';
import claseSunatService from '../../../service/administracion/claseSunatService';
import productoSunatService from '../../../service/administracion/productoSunatService';

import categoriaService from '../../../service/administracion/categoriaService';

import Header from './Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import CargaMasivaModal from './CargaMasivaModal';
import FormConversion from './Conversion/FormConversion';
import FormVariante from './FormVariante';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingPrint: false,
            loadingEdit: false,
            unidadesMedida: [],
            estados: estadoMock.values,
            modelos: [],
            segmentoCategoria: [],
            segmentoFilter: [],
            marcas: [],
            atributos: [],
            catalogoexistencias: [],
            filter: {
                nombre: "",
                codigoRefencia: "",
                idUnidadMedida: 0,
                idMarca: 0,
                idModelo: 0,
                codigoBarra: "",
                estado: '',
                idCategoria: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleVariante: false,
            visibleConversion: false,
            formValues: this.fetchEmptyFormValues(),
            visibleCargaMasiva: false,
        }
    }


    fetchEmptyFormValues = () => {
        return {
            id: 0,
            nombre: '',
            codigoReferencia: '',
            idUnidadMedida: 0,
            idExistencia: 0,
            idExistenciaCatalogo: 0,
            idMarca: 0,
            idPlanCuentaVenta: 0,
            idPlanCuentaCompra: 0,
            peso: 0,
            url: '',
            idModelo: 0,
            idImpuesto: 1,
            stockMax: 0,
            stockMin: 0,
            codigoBarra: '',
            arancelaria: '',
            flagNormalizado: false,
            nombreUnidadMedida: '',
            nombreArchivo: '',
            flagIGVAfecto: true,
            flagISC: false,
            flagGratuito: false,
            flagExonerado: false,
            flagICBPER: false,
            flagVariante: false,
            flagVencimiento: false,
            flagAplicarSerie: false,
            variante: 0,
            unidadesMedida: [],
            existencias: [],
            catalogoexistencias: [],
            marcas: [],
            modelos: [],
            impuesto: [],
            cuentasContablesCompra: [],
            cuentasContablesVenta: [],
            segmentosSunat: [],
            clasesSunat: [],
            familiasSunat: [],
            productosSunat: [],
            listaCargaMasiva: [],
            listaComprobanteDetalle: [],
            atributos: [],
            atributoItem: [],
            varianteItem: [],
            addLoading: false,
            selectedRowKeys: [],
            idVariantes: [],
            varianteItemSelected: [],
            activeKey: "1",
            valuesAtributo: [],
            keysAtributo: [],
            segmentoCategoria: [],
            clasesCategoria: [],
            familiasCategoria: [],
            productosCategoria: [],
            tipoAfectacion: [],
            nivelProducto: [],
        }
    }


    handleChangeTab = (key, onSetFieldsValue) => {

        if (key == "3") { // Metodo de Pago
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idVariantes: [],
                    activeKey: key,
                },
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    activeKey: key,
                },
            });
        }


    };
    handleChangeForm = async (property, value, form) => {

        if (property === "idSegmentoSunat") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const familiasSunat = await familiaSunatService.listarPorIdSegmentoSunat(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    familiasSunat: familiasSunat ? familiasSunat : []
                }
            });
        }

        if (property === "idFamiliaSunat") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const clasesSunat = await claseSunatService.listarPorIdFamiliaSunat(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    clasesSunat: clasesSunat ? clasesSunat : []
                }
            });
        }

        if (property === "idClaseSunat") {
            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const productosSunat = await productoSunatService.listarPorIdClaseSunat(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    productosSunat: productosSunat ? productosSunat : []
                }
            });
        }
        if (property === "flagVencimiento") {
            console.log(value)
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    flagVencimiento: value,
                }
            });
        }


        if (property === "LI") {
            this.setState({ formValues: { ...this.state.formValues, addLoading: true } });

            const atributoItem = await atributoService.listarAtributoItem(value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    addLoading: false,
                    atributoItem: atributoItem ? atributoItem : []
                }
            });
        }
        if (property === "flagVariante") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    variante: value,
                }
            });
        }
        if (property === "idVariantes") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idVariantes: value,
                }
            });
        }

    };


    handleClearFilters = async () => {
        var filter = {
            nombre: "",
            codigoRefencia: "",
            idUnidadMedida: 0,
            idMarca: 0,
            idModelo: 0,
            codigoBarra: "",
            estado: '',
            idCategoria: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await productoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Productos.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await productoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Productos.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await productoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleData = async (id) => {
        const familiasCategoria = await categoriaService.listarPorIdClase(id);

        var segmentoFilter = this.state.segmentoFilter.concat(familiasCategoria);


        const treeData = this.buildTree(segmentoFilter);


        this.setState({
            segmentoFilter: segmentoFilter,
            formValues: {
                ...this.state.formValues,
                segmentoCategoria: treeData
            }
        });
    }

    buildTree = (data) => {
        const tree = [];
        const lookup = {};

        // Crear un mapa de nodos para acceso rápido
        data.forEach((item) => {
            lookup[item.id] = { ...item, children: item.children == null ? [] : item.children };
        });

        data.forEach((item) => {
            if (item.pId) {
                // Si tiene un pId, agregarlo al array `children` de su padre si no está ya incluido
                const parent = lookup[item.pId];
                if (parent && !parent.children.some((child) => child.id === item.id)) {
                    parent.children.push(lookup[item.id]);
                }
            } else {
                // Si no tiene pId, es un nodo raíz
                if (!tree.some((node) => node.id === item.id)) {
                    tree.push(lookup[item.id]);
                }
            }
        });

        return tree;
    };

    genTreeNode = (parentId, isLeaf = false) => {
        const random = Math.random()
            .toString(36)
            .substring(2, 6);
        return {
            id: random,
            pId: parentId,
            value: random,
            title: isLeaf ? 'Tree Node' : 'Expand to load',
            isLeaf,
        };
    };


    handleInactiveActive = (values) => {
        var sms = values.flag ? "deshabilitar el producto " : "habilitar el producto ";

        dialog.confirm("¿Desea " + sms + " " + values.nombre + "?", async () => {
            var response;
            if (values.flag)
                response = await productoService.desactivar(values);
            else
                response = await productoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEliminar = (values) => {

        dialog.confirm("¿Desea eliminar el producto " + values.nombre + "?", async () => {

            var response = await productoService.eliminar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    /******************** FORM MODAL *****************/

    handleNew = () => {
        debugger;
        var formValues = this.fetchEmptyFormValues();
        formValues.unidadesMedida = this.state.unidadesMedida;
        formValues.existencias = this.state.existencias;
        formValues.marcas = this.state.marcas;
        formValues.modelos = this.state.modelos;
        formValues.cuentasContablesCompra = this.state.cuentasContablesCompra;
        formValues.cuentasContablesVenta = this.state.cuentasContablesVenta;
        formValues.segmentoCategoria = this.state.segmentoFilter;
        formValues.segmentosSunat = this.state.segmentosSunat;
        formValues.impuesto = this.state.impuesto;
        formValues.atributos = this.state.atributos;
        formValues.catalogoexistencias = this.state.catalogoexistencias;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        this.setState({ visible: true, formValues });
    };

    handleNewCargaMasiva = () => {
        this.setState({ visibleCargaMasiva: true });
    };

    handleEdit = async (values) => {
        this.setState({ loadingEdit: true });

        const response = await productoService.obtenerPorId(values.id);
        if (response !== undefined) {
            const familiasSunat = await familiaSunatService.listarPorIdSegmentoSunat(response.idSegmentoSunat);
            const clasesSunat = await claseSunatService.listarPorIdFamiliaSunat(response.idFamiliaSunat);
            const productosSunat = await productoSunatService.listarPorIdClaseSunat(response.idClaseSunat);

            const clasesCategoria = response.idSegmentoCate > 0 ? await categoriaService.listarPorIdClase(response.idSegmentoCate) : [];
            const familiasCategoria = response.idFamiliaCate > 0 ? await categoriaService.listarPorIdClase(response.idFamiliaCate) : [];
            const productosCategoria = response.idClaseCate > 0 ? await categoriaService.listarPorIdClase(response.idClaseCate) : [];

            response.familiasSunat = familiasSunat;
            response.clasesSunat = clasesSunat;
            response.productosSunat = productosSunat;
            response.unidadesMedida = this.state.unidadesMedida;
            response.existencias = this.state.existencias;
            response.catalogoexistencias = this.state.catalogoexistencias;
            response.marcas = this.state.marcas;
            response.modelos = this.state.modelos;
            response.cuentasContablesCompra = this.state.cuentasContablesCompra;
            response.cuentasContablesVenta = this.state.cuentasContablesVenta;
            response.segmentosSunat = this.state.segmentosSunat;
            response.impuesto = this.state.impuesto;
            response.atributos = this.state.atributos;
            response.tipoAfectacion = lst_tipo_afectacion;

            response.varianteItemSelected = [];
            response.activeKey = "1";
            response.variante = 0;
            response.keysAtributo = response.hasAtri ? await this.fetchVariantes(response) : [];

            var position = response.nivel;
            /*             response.segmentoCategoria = this.state.segmentoCategoria.filter(e => e.numero == 1);
                        response.familiasCategoria = position == 2 ? this.state.segmentoCategoria : clasesCategoria;
                        response.clasesCategoria = position == 3 ? this.state.segmentoCategoria : familiasCategoria;
                        response.productosCategoria = position == 4 ? this.state.segmentoCategoria : productosCategoria;
              
                        for (let i = position; i <= 4; i++) {
                            newArray.push(i);
                        } */
            let newArray = [];

            var _segmentoCategoria = this.state.segmentoFilter.concat(clasesCategoria).concat(familiasCategoria).concat(productosCategoria)

            response.segmentoCategoria = this.buildTree(_segmentoCategoria);
            response.nivelProducto = newArray;

            this.setState({ visible: true, formValues: response });
        }
        this.setState({ loadingEdit: false });

    };

    fetchVariantes = async (values) => {
        var tipo_campo = null;
        const listaArrays = [];
        const objeto = values.productoAtributo;

        for (let i = 1; i <= 7; i++) {
            if (objeto['idAtributo' + i] !== 0 && objeto['idAtributo' + i] !== null) {

                var codigoAtri = objeto['codigoAtri' + i];
                var idAtributo = objeto['idAtributo' + i];

                var atributoItem = codigoAtri == "LI" ? await atributoService.listarAtributoItem(idAtributo) : [];

                switch (codigoAtri) {
                    case "FE":
                        tipo_campo =
                            <DatePicker
                                style={{ width: '90%', marginRight: 8 }} />
                        break;
                    case "LI":
                        tipo_campo =
                            <Select
                                placeholder="Seleccione Item"
                                style={{ width: '90%', marginRight: 8 }}
                                optionFilterProp="children"
                            >
                                {atributoItem.map((item) => (
                                    <Select.Option key={item.id} value={item.nombre} nombre={item.nombre}>{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        break;
                    case "DE":
                        tipo_campo =
                            <InputNumber
                                placeholder="Ingrese valor"
                                min={0}
                                step={0.2}
                                style={{ width: '90%', marginRight: 8 }} />

                        break;
                    case "NU":
                        tipo_campo =
                            <InputNumber
                                placeholder="Ingrese valor"
                                min={0}
                                style={{ width: '90%', marginRight: 8 }} />
                        break;
                    case "TE":
                        tipo_campo =
                            <Input
                                placeholder="Ingrese valor"
                                style={{ width: '90%', marginRight: 8 }} />
                        break;
                    default:
                        tipo_campo = <Switch
                            checkedChildren="SI"
                            unCheckedChildren="NO"
                            defaultChecked={objeto['atributo' + i] == "true" ? true : false}
                            style={{ width: '10%', marginRight: 8 }} />
                        break;
                }

                listaArrays.push({
                    identifier: global.fetchUniqueCode(),
                    idAtributo: objeto['idAtributo' + i],
                    value: codigoAtri == "BO" ? objeto['atributo' + i] == "true" ? true : false : objeto['atributo' + i],
                    label: objeto['label' + i],
                    input: tipo_campo,
                    codigoAtri: objeto['codigoAtri' + i],
                    edit: true
                });
            }
        }

        return listaArrays;

    };



    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (this.state.formValues.id === 0) {
                if (this.state.formValues.variante == 1) {
                    const processedData = await Promise.all(values.map(async item => {
                        // Perform asynchronous operations on each item
                        response = await productoService.registrar(item);
                    }));
                } else {
                    response = await productoService.registrar(values);
                }
            }

            else {
                values.flagVariante = this.state.formValues.flagVariante;
                response = await productoService.modificar(values);
            }


            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleSaveCargaMasiva = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            response = await productoService.registrarCargaMasiva(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visibleCargaMasiva: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                message.success('Registrado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleDownloadFormatoCargaMasiva = async () => {
        var response = await productoService.formatoCargaMasiva();
        if (response !== undefined)
            global.dowloadFile(response.data, "template-carga-masiva-producto.xlsx");
    };

    handleBarcode = async (values) => {
        debugger;
        if (values.codigoBarra == undefined || values.codigoBarra == null) {
            dialog.error('Producto seleccionado no tiene registrado codigo de barras.');

        } else {

            var response = await productoService.barcode({ valor: values.codigoBarra });

            if (response !== undefined) {
                var file = window.URL.createObjectURL(response.data);
                var win = window.open(file, '_blank');
                win.focus();
            }


            // fromato en pdf image

        }
    };

    handleSaveConversion = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response;
            var producto = values[0];
            response = await productoService.eliminarConversion({ "idProducto": producto.idProducto });

            response = await productoService.registrarConversion(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visibleConversion: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();
                message.success('Registrado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleConversion = async (values) => {

        var params = auth.user().parametros;

        var conversionMedida = params.filter((m) => m.abreviatura === CONVERSION_MEDIDA)[0].valor === "1" ? true : false;
        if (conversionMedida) {
            var response = await productoService.listarConversionProductoPorId(values.id);

            var formValues = this.fetchEmptyFormValues();
            formValues.id = values.id;
            formValues.unidadesMedida = this.state.unidadesMedida;
            formValues.nombre = values.nombre;
            formValues.codigoReferencia = values.codigoReferencia;
            formValues.nombreUnidadMedida = values.nombreUnidadMedida;
            formValues.listaComprobanteDetalle = response ? response : [];

            this.setState({ visibleConversion: true, formValues });
        } else {

            dialog.info('Opción no disponible en su plan actual, contacte a un asesor comercial');

        }

    };

    handleAgregarDetalle = () => {

        var lista = this.state.formValues.listaComprobanteDetalle;
        lista.push({
            identifier: global.fetchUniqueCode(),
            unidadMedida: this.state.formValues.nombreUnidadMedida,
            cantidadBase: 0,
            idUnidadMedida: 0,
            cantidad: 0,
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: lista,
                unidadesMedida: this.state.unidadesMedida
            }
        });
    };
    handleRemove = (item) => {
        var _lista = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: _lista,
            }
        });
    }; te

    handleCancelVariante = () => {
        this.setState({
            visibleVariante: false,
            formValues: {
                ...this.state.formValues,
                varianteItemSelected: [],
                selectedRowKeys: []

            }
        });


    };



    handleCreateBarcode = (form, identifier) => {

        var fecha = new Date();
        const formatoMap = {
            dd: fecha.getDate(),
            mm: (fecha.getMonth() + 1).toString().length == 1 ? +"0" + (fecha.getMonth() + 1).toString() : (fecha.getMonth() + 1).toString(),
            yy: fecha.getFullYear().toString().slice(-2),
            yyyy: fecha.getFullYear()
        };

        var number = "775" + formatoMap.mm + "" + formatoMap.yy;
        var point = -1;
        var positions = 6;
        var float = false;

        if (float) point = Math.floor(Math.random() * positions) + 1;

        for (let i = 0; i < positions; i++) {
            if (i == point) number += ".";
            number += Math.floor(Math.random() * 10);
        }

        if (identifier == null || identifier === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    codigoBarra: number,
                }
            });

            form.setFieldsValue({
                codigoBarra: number
            });
        } else {
            form.setFieldsValue({
                [`variant[${identifier}]`]: number
            });
        }



    };


    handleMultiCreateBarcode = (form) => {
        var items = this.state.formValues.varianteItemSelected;
        var fecha = new Date();
        const formatoMap = {
            dd: fecha.getDate(),
            mm: (fecha.getMonth() + 1).toString().length == 1 ? +"0" + (fecha.getMonth() + 1).toString() : (fecha.getMonth() + 1).toString(),
            yy: fecha.getFullYear().toString().slice(-2),
            yyyy: fecha.getFullYear()
        };

        items.forEach(item => {

            var number = "775" + formatoMap.mm + "" + formatoMap.yy;
            var point = -1;
            var positions = 6;
            var float = false;

            if (float) point = Math.floor(Math.random() * positions) + 1;

            for (let i = 0; i < positions; i++) {
                if (i == point) number += ".";
                number += Math.floor(Math.random() * 10);
            }
            form.setFieldsValue({
                [`variant[${item.identifier}]`]: number
            });
        });



    };
    handleOpenVariante = async (value, onSetFieldsValue) => {

        //this.setState({ formValues: { ...this.state.formValues, addLoading: true } });
        let varianteItem = [];

        if (value.length > 0) {
            varianteItem = await atributoService.listarAtributoItem(value);
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                varianteItem: varianteItem ? varianteItem : [],
                idVariantes: value
            }
        });


        this.setState({
            visibleVariante: true
        });
    };


    handleSelectProduct = (selected, rows) => {
        var varianteItemSelected = [];
        const peopleByAge = Object.groupBy(rows, (person) => person.idAtributo);

        if ((Object.keys(peopleByAge).length) > 1) {
            this.state.formValues.idVariantes.forEach((vari, i) => {
                i++
                var rowsVariante = rows.filter(m => m.idAtributo === vari);

                var nextVariante = rows.filter(m => m.idAtributo === this.state.formValues.idVariantes[i]);

                rowsVariante.forEach(nivel1 => {
                    nextVariante.forEach(nivel2 => {
                        var item = {
                            identifier: global.fetchUniqueCode(),
                            id: nivel1.id,
                            idAtributoItem: nivel1.id,
                            idAtributo: nivel1.idAtributo,
                            nombre: nivel1.nombre + '-' + nivel2.nombre,
                        };
                        varianteItemSelected.push(item);
                    });
                });

            });
        } else {
            rows.forEach(row => {
                var item = {
                    identifier: global.fetchUniqueCode(),
                    id: row.id,
                    idAtributoItem: row.id,
                    idAtributo: row.idAtributo,
                    nombre: row.abreviatura + '-' + row.nombre,
                };
                varianteItemSelected.push(item);
            });
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                varianteItemSelected: varianteItemSelected,
                selectedRowKeys: selected
            }
        });
    };


    handleRemoveVariante = (item) => {
        var varianteItemSelected = this.state.formValues.varianteItemSelected.filter((m) => m.identifier !== item.identifier);
        var selected = this.state.formValues.selectedRowKeys.filter((m) => m !== item.id);

        this.setState({
            formValues: {
                ...this.state.formValues,
                varianteItemSelected: varianteItemSelected,
                selectedRowKeys: selected
            },
        });
    };

    handleChangeVariante = async (value, onSetFieldsValue) => {

        let varianteItem = [];

        if (value.length > 0) {
            varianteItem = await atributoService.listarAtributoItem(value);
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                varianteItem: varianteItem ? varianteItem : [],
                idVariantes: value
            }
        });


        this.setState({
            visibleVariante: true
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, productoService.paginacion);
        const unidadesMedida = await unidadMedidaService.listar();
        const existencias = await existenciaService.listarSunat(0);
        const marcas = await marcaService.listar();
        const modelos = await modeloService.listar();

        const segmentosSunat = await segmentoSunatService.listar();
        const cuentasContablesVenta = await planCuentaService.listarCuentaContableId({ cuentaContable: '70' });
        const cuentasContablesCompra = await planCuentaService.listarCuentaContableId({ cuentaContable: '60' });

        //const impuesto = await productoService.listarImpuesto();
        const atributos = await atributoService.listar();
        const segmentoCategoria = await categoriaService.listar();

        this.setState({
            loadingSource: false,
            unidadesMedida: unidadesMedida ? unidadesMedida.filter(value => value.codigoSunat != "ZZ") : [],
            existencias: existencias ? existencias.filter(e => e.tipoExistencia == 1) : [],
            marcas: marcas ? marcas : [],
            modelos: modelos ? modelos : [],
            cuentasContablesVenta: cuentasContablesVenta ? cuentasContablesVenta : [],
            cuentasContablesCompra: cuentasContablesCompra ? cuentasContablesCompra : [],
            catalogoexistencias: existencias ? existencias.filter(e => e.tipoExistencia == 2) : [],

            segmentosSunat: segmentosSunat ? segmentosSunat : [],
            atributos: atributos ? atributos : [],

            segmentoCategoria: segmentoCategoria ? segmentoCategoria : [],
            segmentoFilter: segmentoCategoria ? segmentoCategoria : [],


        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Producto"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onNewCargaMasiva={this.handleNewCargaMasiva}
                    loadingNewCargaMasiva={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    unidadesMedida={this.state.unidadesMedida}
                    estados={this.state.estados}
                    marcas={this.state.marcas}
                    modelos={this.state.modelos}
                    segmentoCategoria={this.state.segmentoFilter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    onData={this.handleData}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onInactiveActive={this.handleInactiveActive}
                    onEliminar={this.handleEliminar}
                    onChange={this._handleChangePagination}
                    handleBarcode={this.handleBarcode}
                    handleConversion={this.handleConversion}
                />
                <FormModal
                    visible={this.state.visible}
                    segmentoCategoria={this.state.segmentoCategoria}
                    formValues={this.state.formValues}
                    onChangeForm={this.handleChangeForm}
                    onUploadFile={productoService.subirImagen}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onBarcode={this.handleCreateBarcode}
                    handleGenerateBarcode={this.handleMultiCreateBarcode}
                    openModal={this.handleOpenVariante}
                    onRemove={this.handleRemoveVariante}
                    onChangeTab={this.handleChangeTab}
                    onData={this.handleData}
                />

                <FormConversion
                    visible={this.state.visibleConversion}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    formValues={this.state.formValues}
                    handleRemoveDetails={this.handleRemove}
                    onClose={() => this.setState({ visibleConversion: false })}
                    onSaveConversion={this.handleSaveConversion}
                />
                <CargaMasivaModal
                    onDownloadFormatoCargaMasiva={this.handleDownloadFormatoCargaMasiva}
                    visible={this.state.visibleCargaMasiva}
                    formValues={this.state.formValues}
                    onUploadFile={productoService.subirCargaMasiva}
                    onClose={() => this.setState({ visibleCargaMasiva: false })}
                    onSave={this.handleSaveCargaMasiva}
                />

                <FormVariante
                    visible={this.state.visibleVariante}
                    formValues={this.state.formValues}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onClose={this.handleCancelVariante}
                    onSave={() => this.setState({ visibleVariante: false })}
                    onChangeRow={this.handleSelectProduct}
                    onChangeForm={this.handleChangeVariante}

                />
            </div>
        );
    };
}